import { render, staticRenderFns } from "./UpsertMedicalPractitioner.vue?vue&type=template&id=5cab25ab&scoped=true"
import script from "./UpsertMedicalPractitioner.vue?vue&type=script&lang=ts"
export * from "./UpsertMedicalPractitioner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab25ab",
  null
  
)

export default component.exports